import { render, staticRenderFns } from "./NewEvent.vue?vue&type=template&id=9801600e&"
import script from "./NewEvent.vue?vue&type=script&lang=js&"
export * from "./NewEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/devteam/projects/dominion-conference-app/ConferenceAdmin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports